export const EXPENSES_TEST_FLAG = 'expenses-test-flag'

export const REMOTE_FEATURE_FLAG_PROXY_PATH = '/ff/precompute-assignments'
